import { render, staticRenderFns } from "./gptTranslate.vue?vue&type=template&id=6b13a3a2&scoped=true"
import script from "./gptTranslate.vue?vue&type=script&lang=js"
export * from "./gptTranslate.vue?vue&type=script&lang=js"
import style0 from "./gptTranslate.vue?vue&type=style&index=0&id=6b13a3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b13a3a2",
  null
  
)

export default component.exports